import { useState, useEffect } from 'react';

type Theme = 'light' | 'dark';

const THEME_KEY = 'letsmakeiteasy-theme';

export const useTheme = () => {
  const [theme, setTheme] = useState<Theme>(() => {
    // Only run on client
    if (typeof window === 'undefined') return 'light';
    
    // Check localStorage first
    const stored = localStorage.getItem(THEME_KEY) as Theme | null;
    if (stored === 'light' || stored === 'dark') return stored;
    
    // Fallback to user's local time: 
    // Pagi - Sore (06:00 - 18:00) -> light mode
    // Malam - Pagi (18:00 - 06:00) -> dark mode
    const hour = new Date().getHours();
    return (hour >= 6 && hour < 18) ? 'light' : 'dark';
  });

  useEffect(() => {
    const root = document.documentElement;
    
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
  };

  return { theme, toggleTheme };
};